class CareerVideo {

  constructor() {
    this.play()
    this.cinema = document.querySelector('.career-teams__cinema')
    this.video = document.querySelector('.career-teams__video')
  }
  play() {
    document.addEventListener('click', (ev) => {
      if (ev.target.dataset.video) {
        this.playVideo(ev.target.dataset.video)
      }
      if (ev.target.previousElementSibling && ev.target.previousElementSibling.dataset.video) {
        this.playVideo(ev.target.previousElementSibling.dataset.video)
      }
      if (ev.target.children[0] && ev.target.children[0].dataset.video) {
        this.playVideo(ev.target.children[0].dataset.video)
      }
      if (ev.target.classList.contains('career-teams__cinema--show') ||
          ev.target.classList.contains('career-teams__cinema-close')) {
        this.closeVideo()
      }
    })

    addEventListener('keydown', (ev) => {
      if (ev.key === "Escape" && document.querySelector('.career-teams__cinema--show')) {
        this.closeVideo()
      }
    })
  }

  playVideo(url) {
    if (url.slice(-3).toLowerCase() !== "mp4" || this.playing) return
    document.body.classList.add('noscroll')
    this.video.src = url
    this.cinema.classList.add('career-teams__cinema--show')
    setTimeout(() => {
      this.video.play()
    }, 500)
  }

  closeVideo() {
    document.body.classList.remove('noscroll')
    this.video.currentTime = 0
    this.video.pause()
    this.cinema.classList.remove('career-teams__cinema--show')
  }

}

export default CareerVideo